import {Header} from "@/components/Header";

export const Contact = () => {
	return (
		<>
			<div className="w-full bg-white flex flex-col items-center">
				<Header/>
				<img
					src="/banners/banner-contact.jpg"
					alt="Information Banner"
					className="w-full object-cover shadow-lg"
				/>
			</div>
			<div
				className="flex flex-col md:flex-row md:justify-center md:items-start text-center mt-20 px-4 md:px-16 gap-10">
				<div className="flex flex-col items-center">
					<img src="/other_imgs/image-suggestion.png" alt="suggestion_img"
					     className="w-64 h-64 md:w-80 md:h-80"/>
					<h2 className="font-custom-bold mt-5 text-red-700 text-xl md:text-2xl">सूचना</h2>
				</div>
				<div className="flex flex-col items-center">
					<img src="/other_imgs/image-query.png" alt="question-img" className="w-64 h-64 md:w-80 md:h-80"/>
					<h2 className="font-custom-bold mt-5 text-red-700 text-xl md:text-2xl">प्रश्न?</h2>
				</div>
				<div className="flex flex-col items-center">
					<img src="/other_imgs/image-update-kulvruksh.png" alt="kulvrush img"
					     className="w-64 h-64 md:w-80 md:h-80"/>
					<h2 className="font-custom-bold mt-5 text-red-700 text-xl md:text-2xl"> कुलवृक्ष माहिती अपडेट
						करा</h2>
				</div>
			</div>
			<div className="text-center mt-10 font-custom-regular mb-16 px-4">
				<h1 className="font-custom-bold mb-5 text-xl md:text-2xl">जोगळेकर कुलवृत्तान्त समिती द्वारा </h1>
				<p className="font-custom-regular text-lg md:text-xl mb-5">
					<span className="font-custom-bold">श्री. विजय केशव जोगळेकर - अध्यक्ष</span>
					<br/>
					१२१०/क , शिवाजीनगर , 'शिवगंगा', ऑफ आपटे रोड पुणे ४११००४
				</p>
				<h2 className="font-custom-bold text-xl md:text-2xl mb-5">भ्रमणध्वनी :- ९४२१० ५३२२३</h2>
				<span className="text-lg md:text-xl">इ-मेल :- info@joglekarkul.com</span>
			</div>
		</>
	);
};
